export default class IntersectionObserverScroll {
  constructor(targetSelector, activeClass) {
    this.targetSelector = targetSelector;
    this.activeClass = activeClass;
    this._intersectionObserver();
  }

  _intersectionObserver() {
    const observerOptions = {
      root: null,
      threshold: 0.5,
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          entry.target.classList.add(this.activeClass);
        } else {
          entry.target.classList.remove(this.activeClass);
        }
      });
    };

    document.querySelectorAll(this.targetSelector).forEach((element) => {
      const observer = new IntersectionObserver(
        handleIntersection,
        observerOptions,
      );
      observer.observe(element);
    });
  }
}
